import React from "react";
import { Layout } from "antd";

import { ErrorBoundaries } from "@ui/errors";

import { ApiMessage, Footer, Header, PageLoader, SubHeader } from "..";

import "../styles.scss";

const { Content } = Layout;

const ProtectedLayout = ({ children }) => {
  return (
    <ErrorBoundaries>
      <React.Suspense fallback={<PageLoader />}>
        <Layout className="drs-layout">
          <Header />
          <Content className="drs-layout-content">
            <ApiMessage />
            <SubHeader />
            <div className="drs-layout-component">{children}</div>
          </Content>
          <Footer />
        </Layout>
      </React.Suspense>
    </ErrorBoundaries>
  );
};

export default ProtectedLayout;